import NProgress from 'nprogress';
import './nprogress.scss';

NProgress.configure({
  showSpinner: false,
  speed: 500,
});



// WEBPACK FOOTER //
// ./theme/nprogress.js